import dayjs from "dayjs";
import {convertDateStringToDateTimezone_7, formatToCurrencyType} from "helper/common";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";

const {
  INPUT,
  DATE,
  SELECT,
  AUTO_COMPLETE,
  CURRENCY,
  DATE_ON,
  NUMBER,
  CHECKBOX,
  RADIO,
  NORMAL_CHECKBOX,
} = FIELD_TYPE;

const cssProps = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 8, xl: 8},
};

const cssProps2 = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
};

const discountsInfo = [
  {
    type: INPUT,
    name: "maChuongTrinh",
    label: "Mã chương trình",
    ...cssProps,
    rules: [
      {
        max: 10,
        message: "Định dạng mã chương trình không đúng",
      },
    ],
  },
  {
    type: INPUT,
    name: "tenChuongTrinh",
    label: "Tên chương trình",
    ...cssProps,
    rules: [
      {
        max: 200,
        message: "Định dạng mã thẻ không đúng",
      },
    ],
  },
  {
    type: DATE,
    disableDate: false,
    needConfirm:false,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
    label: "Ngày tạo từ",
    name: "ngayTaoTu",
    ...cssProps,
  },
  {
    type: DATE,
    disableDate: false,
    needConfirm:false,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
    label: "Ngày tạo đến",
    name: "ngayTaoDen",
    ...cssProps,
  },
  {
    type: INPUT,
    name: "nguoiTao",
    label: "Người tạo",
    allowClear: true,
    ...cssProps,
    rules: [
      {
        max: 50,
        message: "Định dạng mã thẻ không đúng",
      },
    ],
  },
  {
    type: DATE,
    disableDate: false,
    needConfirm:false,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
    label: "Áp dụng từ",
    name: "ngayBatDau",
    ...cssProps,
  },
  {
    type: DATE,
    disableDate: false,
    needConfirm:false,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
    label: "Áp dụng đến",
    name: "ngayKetThuc",
    ...cssProps,
  },
];

const discountsColumns = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (v, r, i) => i + 1,
    align:"center",
  },
  {
    title: "Mã chương trình",
    dataIndex: "maChuongTrinh",
    show: true,
    align: "left",
    width:"7%"
  },
  {
    title: "Tên chương trình",
    dataIndex: "tenChuongTrinh",
    show: true,
    align: "left",
    width:"30%"
  },
  {
    title: "Ngày tạo",
    dataIndex: "createdDate",
    show: true,
    align: "center",
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Người tạo",
    dataIndex: "nguoiTao",
    show: true,
    align: "left",
  },
  {
    title: "Áp dụng từ",
    dataIndex: "ngayBatDau",
    show: true,
    align: "center",
    width:"5%",
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Áp dụng đến",
    dataIndex: "ngayKetThuc",
    show: true,
    align: "center",
    width:"6%",
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThai",
    show: true,
    align: "center",
    // render: (v, r, idx) => 
    //   {
    //       if(v === 0)
    //         {
    //           return "Chưa kích hoạt";
    //         }
    //       else if(v === 1)
    //         {
    //           return "Hiệu lực";
    //         }
    //       else if(v === 2)
    //         {
    //           return "Hết hiệu lực";
    //         }
    //   },
    width: "8%",
  },
  {
    title: "Mô tả",
    dataIndex: "moTa",
    show: true,
    align: "left",
   // width: "8%",
  },
  {
    title: "Tác vụ",
    dataIndex: "action",
    show: true,
    align: "center",
    width: "8%",
  },
];

export {discountsInfo, discountsColumns};
